
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { lambda_type, unit_type, list_type, class_type, record_type, option_type, float64_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState__startLoading, FormState__setValidationResponse_5219762A, ToolId__get_unwrap, FormState_get_empty, RequestedValue$1, TokenDataDto_$reflection, FormState_$reflection, RequestedValue$1_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { DataTransfer_DetailSet_$reflection } from "../../Shared/Set.js";
import { Helper_toolId, ToolTypes_$reflection } from "../../Shared/Tool.js";
import { MultiStateLostToolWithQuantityDto, MultiUpdateStateToLostStateDto, MultiUpdateStateToLostStateDto_$reflection } from "../../Shared/MultiOperation.js";
import { length, tryHead, toArray as toArray_1, tryPick, contains, append as append_1, collect, singleton as singleton_1, filter, cons, find, ofArray, map, empty, isEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_none, Cmd_ofEffect, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { iterate, toArray, empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { getSelectedSets } from "../../Requests/Set.js";
import { Cmd_getSelectedTools } from "../../Requests/Tool.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { toArray as toArray_2, unwrap, defaultArg, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { numberInputIntMaxValue, toISOString } from "../../Common.js";
import { newGuid } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { createObj, equals, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { FSharpMap__get_IsEmpty, toList as toList_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ColumnDefinition$1, CellContent } from "../Table/Types.js";
import { InvalidTextValue } from "../../Components/Text.js";
import { NumberInput } from "../../Components/Input.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { InfiniteTable } from "../Table/InfiniteTable.js";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { TableControlElement$1, TableControl$1 } from "../Table/Table.js";
import { TabsMenu } from "../TabsMenu.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { TextArea } from "../../Components/TextArea.js";
import { Button } from "../../Components/Button.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { Skeleton } from "../../Components/Skeleton.js";

export class TableElementType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "ToolWithQuantity", "Set"];
    }
}

export function TableElementType_$reflection() {
    return union_type("Widgets.Modals.MultiSetLostStateModal.TableElementType", [], TableElementType, () => [[], [], []]);
}

export class TableElement extends Record {
    constructor(Id, ElementId, Manufacturer, Model, Name, AdditionalName, InventoryNumber, Quanity, Type) {
        super();
        this.Id = Id;
        this.ElementId = ElementId;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.Name = Name;
        this.AdditionalName = AdditionalName;
        this.InventoryNumber = InventoryNumber;
        this.Quanity = Quanity;
        this.Type = Type;
    }
}

export function TableElement_$reflection() {
    return record_type("Widgets.Modals.MultiSetLostStateModal.TableElement", [], TableElement, () => [["Id", string_type], ["ElementId", string_type], ["Manufacturer", string_type], ["Model", string_type], ["Name", string_type], ["AdditionalName", string_type], ["InventoryNumber", string_type], ["Quanity", option_type(float64_type)], ["Type", TableElementType_$reflection()]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Assign", "SetComment", "SetLostDate", "SetQuantity", "AddElement", "RemoveElement", "InitTableElements", "AssignedResponse", "SetsFetched", "ToolsFetched", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.Modals.MultiSetLostStateModal.Msg", [], Msg, () => [[], [["Item", string_type]], [["Item", option_type(class_type("System.DateTime"))]], [["id", string_type], ["quantity", option_type(float64_type)]], [["id", string_type]], [["id", string_type]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", list_type(DataTransfer_DetailSet_$reflection())]], [["Item", list_type(ToolTypes_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(SuccessCallback, OnClose, Sets, Tools, TableElements, RemovedElements, Dto, LostDate, FormState, UserData) {
        super();
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Sets = Sets;
        this.Tools = Tools;
        this.TableElements = TableElements;
        this.RemovedElements = RemovedElements;
        this.Dto = Dto;
        this.LostDate = LostDate;
        this.FormState = FormState;
        this.UserData = UserData;
    }
}

function State_$reflection() {
    return record_type("Widgets.Modals.MultiSetLostStateModal.State", [], State, () => [["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Sets", RequestedValue$1_$reflection(list_type(DataTransfer_DetailSet_$reflection()))], ["Tools", RequestedValue$1_$reflection(list_type(ToolTypes_$reflection()))], ["TableElements", list_type(TableElement_$reflection())], ["RemovedElements", list_type(TableElement_$reflection())], ["Dto", MultiUpdateStateToLostStateDto_$reflection()], ["LostDate", option_type(class_type("System.DateTime"))], ["FormState", FormState_$reflection()], ["UserData", TokenDataDto_$reflection()]]);
}

function init(successCallback, onClose, userData, senderId, assignProps) {
    return [new State(successCallback, onClose, isEmpty(assignProps.SetIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), isEmpty(assignProps.ToolIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), empty(), empty(), new MultiUpdateStateToLostStateDto(empty(), empty(), empty(), senderId, "", undefined), undefined, FormState_get_empty(), userData), Cmd_batch(toList(delay(() => append(!isEmpty(assignProps.SetIds) ? singleton(getSelectedSets(assignProps.SetIds, (Item) => (new Msg(8, [Item])), (Item_1) => (new Msg(10, [Item_1])))) : empty_1(), delay(() => (!isEmpty(assignProps.ToolIds) ? singleton(Cmd_getSelectedTools(map(ToolId__get_unwrap, assignProps.ToolIds), (Item_2) => (new Msg(9, [Item_2])), (Item_3) => (new Msg(10, [Item_3])))) : empty_1()))))))];
}

function update(msg, state) {
    let bind$0040_1, bind$0040_2;
    switch (msg.tag) {
        case 7: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.LostDate, FormState__setValidationResponse_5219762A(state.FormState, response_2.fields[0]), state.UserData), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.LostDate, FormState_get_empty(), state.UserData), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 3:
            return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, map((tableElement) => {
                if (tableElement.Id === msg.fields[0]) {
                    return new TableElement(tableElement.Id, tableElement.ElementId, tableElement.Manufacturer, tableElement.Model, tableElement.Name, tableElement.AdditionalName, tableElement.InventoryNumber, msg.fields[1], tableElement.Type);
                }
                else {
                    return tableElement;
                }
            }, state.TableElements), state.RemovedElements, state.Dto, state.LostDate, state.FormState, state.UserData), Cmd_none()];
        case 1:
            return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, (bind$0040_1 = state.Dto, new MultiUpdateStateToLostStateDto(bind$0040_1.ToolIds, bind$0040_1.SetIds, bind$0040_1.ToolsWithQuantity, bind$0040_1.ReceiverId, msg.fields[0], bind$0040_1.LostDate)), state.LostDate, state.FormState, state.UserData), Cmd_none()];
        case 2: {
            const date = msg.fields[0];
            return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, (bind$0040_2 = state.Dto, new MultiUpdateStateToLostStateDto(bind$0040_2.ToolIds, bind$0040_2.SetIds, bind$0040_2.ToolsWithQuantity, bind$0040_2.ReceiverId, bind$0040_2.Comment, map_1(toISOString, date))), date, state.FormState, state.UserData), Cmd_none()];
        }
        case 4: {
            const id_1 = msg.fields[0];
            return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, cons(find((tableElement_1) => (tableElement_1.Id === id_1), state.RemovedElements), state.TableElements), filter((tableElement_2) => (tableElement_2.Id !== id_1), state.RemovedElements), state.Dto, state.LostDate, state.FormState, state.UserData), Cmd_none()];
        }
        case 5: {
            const id_2 = msg.fields[0];
            const selectedElement_1 = find((tableElement_3) => (tableElement_3.Id === id_2), state.TableElements);
            return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, filter((tableElement_4) => (tableElement_4.Id !== id_2), state.TableElements), cons(selectedElement_1, state.RemovedElements), state.Dto, state.LostDate, state.FormState, state.UserData), Cmd_none()];
        }
        case 8:
            return [new State(state.SuccessCallback, state.OnClose, new RequestedValue$1(1, [msg.fields[0]]), state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.LostDate, state.FormState, state.UserData), singleton_1((dispatch) => {
                dispatch(new Msg(6, []));
            })];
        case 9:
            return [new State(state.SuccessCallback, state.OnClose, state.Sets, new RequestedValue$1(1, [msg.fields[0]]), state.TableElements, state.RemovedElements, state.Dto, state.LostDate, state.FormState, state.UserData), singleton_1((dispatch_1) => {
                dispatch_1(new Msg(6, []));
            })];
        case 6: {
            const matchValue = state.Tools;
            const matchValue_1 = state.Sets;
            let matchResult, sets, tools;
            if (matchValue.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_1.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                sets = matchValue_1.fields[0];
                tools = matchValue.fields[0];
            }
            switch (matchResult) {
                case 0: {
                    const setToolIds = map((tool) => tool.ToolId, collect((set$) => set$.AssignedTools, sets));
                    return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, append_1(map((set$_1) => (new TableElement(newGuid(), set$_1.Id, set$_1.MasterData.Manufacturer, set$_1.MasterData.Model, set$_1.MasterData.Name, "", set$_1.MasterData.InventoryNumber, undefined, new TableElementType(2, []))), sets), map((tool_2) => {
                        if (tool_2.tag === 1) {
                            const tool_4 = tool_2.fields[0];
                            let quantity;
                            const matchValue_3 = state.Dto.ReceiverId;
                            if (matchValue_3 != null) {
                                const senderId = matchValue_3;
                                quantity = find((ua) => (ua.UserId === senderId), tool_4.UserAssignments).Quantity;
                            }
                            else {
                                quantity = 0;
                            }
                            return new TableElement(newGuid(), ToolId__get_unwrap(tool_4.Id), tool_4.Manufacturer, tool_4.Model, tool_4.DisplayName, "", tool_4.InventoryNumber, quantity, new TableElementType(1, []));
                        }
                        else {
                            const tool_3 = tool_2.fields[0];
                            return new TableElement(newGuid(), ToolId__get_unwrap(tool_3.Id), tool_3.Manufacturer, tool_3.Model, tool_3.DisplayName, "", tool_3.InventoryNumber, undefined, new TableElementType(0, []));
                        }
                    }, filter((tool_1) => !contains(ToolId__get_unwrap(Helper_toolId(tool_1)), setToolIds, {
                        Equals: (x_1, y) => (x_1 === y),
                        GetHashCode: (x_1) => (stringHash(x_1) | 0),
                    }), tools))), state.RemovedElements, state.Dto, state.LostDate, state.FormState, state.UserData), Cmd_none()];
                }
                default:
                    return [state, Cmd_none()];
            }
        }
        case 10:
            return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.LostDate, FormState_get_empty(), state.UserData), Cmd_errorToast("general.a_error_occured")];
        default: {
            let updatedDto;
            const bind$0040 = state.Dto;
            updatedDto = (new MultiUpdateStateToLostStateDto(map((element_1) => element_1.ElementId, filter((element) => equals(element.Type, new TableElementType(0, [])), state.TableElements)), map((element_3) => element_3.ElementId, filter((element_2) => equals(element_2.Type, new TableElementType(2, [])), state.TableElements)), map((element_5) => (new MultiStateLostToolWithQuantityDto(element_5.ElementId, defaultArg(map_1((value) => (~~value | 0), element_5.Quanity), 0))), filter((element_4) => equals(element_4.Type, new TableElementType(1, [])), state.TableElements)), bind$0040.ReceiverId, bind$0040.Comment, bind$0040.LostDate));
            return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.LostDate, FormState__startLoading(state.FormState), state.UserData), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), ["/api/multi-operations/state/lost", toString(0, Auto_generateBoxedEncoder_437914C6(MultiUpdateStateToLostStateDto_$reflection(), undefined, undefined, undefined)(updatedDto))], (Item) => (new Msg(7, [Item])), (Item_1) => (new Msg(10, [Item_1])))];
        }
    }
}

function elementValidation(translate, formState, elementId) {
    return tryPick((tupledArg) => {
        const affectedProperty = tupledArg[0];
        if (affectedProperty.startsWith(concat(elementId, ..."-")) && (affectedProperty !== concat(elementId, ..."-stock"))) {
            return translate(tupledArg[1]);
        }
        else {
            return undefined;
        }
    }, toList_1(formState.Validations));
}

function Table(props) {
    let elems_2;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const columnDefinition = toArray(delay(() => append(!FSharpMap__get_IsEmpty(props.FormState.Validations) ? singleton(new ColumnDefinition$1("hint", "", t("assign_multiple_tools_dialog.hint"), (row) => {
        const matchValue = elementValidation(t, props.FormState, row.ElementId);
        if (matchValue == null) {
            return new CellContent(0, [""]);
        }
        else {
            const value = matchValue;
            return new CellContent(2, [createElement(InvalidTextValue, {
                TestId: concat(row.ElementId, ..."-validation-message"),
                Text: value,
            })]);
        }
    }, "none", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("manufacturer", "", t("assign_multiple_tools_dialog.manufacturer"), (row_1) => (new CellContent(0, [row_1.Manufacturer])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("model", "", t("assign_multiple_tools_dialog.model"), (row_2) => (new CellContent(0, [row_2.Model])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("name", "", t("tool.displayname"), (row_3) => (new CellContent(0, [row_3.Name])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventoryNumber", "", t("assign_multiple_tools_dialog.inventory_number"), (row_4) => (new CellContent(0, [row_4.InventoryNumber])), "none", "text")), delay(() => singleton(new ColumnDefinition$1("quantity", "", t("general.quantity_3"), (row_5) => {
        let Value, ValidationMessage;
        const matchValue_1 = row_5.Type;
        switch (matchValue_1.tag) {
            case 0:
            case 2:
                return new CellContent(0, ["1"]);
            default:
                return new CellContent(2, [createElement(NumberInput, (Value = map_1((value_1) => value_1, row_5.Quanity), (ValidationMessage = FormState__getValidation(props.FormState, t, concat(row_5.ElementId, ..."-stock")), {
                    ComponentState: componentState,
                    MaxValue: numberInputIntMaxValue,
                    OnChange: (value_2) => {
                        props.Dispatch(new Msg(3, [row_5.Id, value_2]));
                    },
                    TestId: concat("multi-lost-", row_5.Id, ..."-quantity-input"),
                    ValidationMessage: unwrap(ValidationMessage),
                    Value: unwrap(Value),
                })))]);
        }
    }, "none", "text"))))))))))))));
    const elementTable = (tableKey, rows, onSelected) => {
        let elems, TableRows, Options;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "basis-[36rem]", "min-h-[36rem]", "overflow-hidden"])], (elems = [createElement(InfiniteTable, (TableRows = toArray_1(rows), (Options = {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["manufacturer", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "singleRow",
            SaveTableConfiguration: false,
            WithQueryParameters: false,
        }, {
            ColumnDefinitions: columnDefinition,
            Controls: singleton_1(new TableControlElement$1(0, [new TableControl$1(t("general.remove"), Recycle_Bin_1(), props.FormState.IsLoading ? undefined : ((rows_1) => {
                iterate((row_6) => {
                    props.Dispatch(onSelected(row_6.Id));
                }, toArray_2(tryHead(rows_1)));
            }), true, false, "tools-dialog-toolreservation-dialog-remove-button")])),
            Options: Options,
            TableKey: tableKey,
            TableRows: TableRows,
        })))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "flex", "flex-col", "flex-1"])], (elems_2 = toList(delay(() => {
        let elems_1, arg_1;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4", "mb-4"])], (elems_1 = [createElement(TabsMenu, {
            Tabs: ofArray([{
                IsSelected: props.IsAddedElementTabVisible,
                Label: t("assign_multiple_tools_dialog.tools"),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(true);
                },
                TestId: "multi-modal-tab-elements",
            }, {
                IsSelected: !props.IsAddedElementTabVisible,
                Label: (arg_1 = {
                    numberOfRemovedTools: length(props.RemovedElements),
                }, patternInput[1].t("assign_multiple_tools_dialog.removed_elements", arg_1)),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(false);
                },
                TestId: "multi-modal-tab-removed-elements",
            }]),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => (props.IsAddedElementTabVisible ? singleton(elementTable("multi-set-lost-state-elements", props.TableElements, (id) => (new Msg(5, [id])))) : singleton(elementTable("multi-set-lost-state-removed-elements", props.RemovedElements, (id_1) => (new Msg(4, [id_1])))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function Form(props) {
    let elems_1, elems, Label_2;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4", "mt-4", "w-96"])], (elems_1 = [createElement(DatePicker, {
        ComponentState: componentState,
        IsClearable: true,
        Label: t("general.date"),
        OnChange: (arg) => {
            props.Dispatch(new Msg(2, [arg]));
        },
        TestId: "lost-dialog-date-test-id",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "date")),
        Value: unwrap(props.LostDate),
    }), createElement(TextArea, {
        ComponentState: componentState,
        Label: t("general.comment"),
        OnChange: (value_1) => {
            props.Dispatch(new Msg(1, [value_1]));
        },
        TestId: "lost-dialog-comment-test-id",
        Value: props.Dto.Comment,
    }), reactElement("div", createObj(singleton_1((elems = [createElement(Button, (Label_2 = t("general.save"), {
        ComponentState: (componentState === "disabled") ? "disabled" : (props.IsTableElementsEmpty ? "disabled" : "enabled"),
        Label: Label_2,
        OnClick: () => {
            props.Dispatch(new Msg(0, []));
        },
        TestId: "tools-dialog-toolreservation-save-button",
        Variant: "primary",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function Content(props) {
    let elems_2, elems_1;
    const patternInput = useTranslation();
    const patternInput_1 = reactApi.useState(true);
    const isAddedElementsTabSelected = patternInput_1[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "flex", "flex-col", "flex-1"])], (elems_1 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "flex-1"])], (elems = [createElement(Table, {
            Dispatch: props.Dispatch,
            FormState: props.FormState,
            IsAddedElementTabVisible: isAddedElementsTabSelected,
            RemovedElements: props.RemovedElements,
            SetIsAddedElementTabVisible: patternInput_1[1],
            TableElements: props.TableElements,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => (isAddedElementsTabSelected ? singleton(createElement(Form, {
            Dispatch: props.Dispatch,
            Dto: props.Dto,
            FormState: props.FormState,
            IsTableElementsEmpty: isEmpty(props.TableElements),
            LostDate: unwrap(props.LostDate),
        })) : empty_1())));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function MultiSetLostStateModalSheet(props) {
    let elems, matchValue, matchValue_1;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.SuccessCallback, props.OnClose, props.UserData, props.SenderId, props.Props), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput[0];
    const patternInput_1 = useTranslation();
    return reactElement("div", createObj(singleton_1((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (matchValue = state_1.Sets, (matchValue_1 = state_1.Tools, (matchValue.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_1.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : createElement(Content, {
            Dispatch: patternInput[1],
            Dto: state_1.Dto,
            FormState: state_1.FormState,
            LostDate: unwrap(state_1.LostDate),
            RemovedElements: state_1.RemovedElements,
            TableElements: state_1.TableElements,
        })))),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: patternInput_1[0]("general.report_lost"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

